module.exports = __webpack_public_path__ + "media/images/placeholders/screenloop-video-placeholder-v2-5354786f4ec70b3685e0fdcd42d69b42.svg";